<template>
  <div
    class="lista-servicos"
  >
    <div
      id="lista-servicos-inbox-counter"
      class="lista-servicos-inbox-counter"
    />
    <el-row>
      <FuncionalidadeHeader
        :titulo="titulo"
        :voltar="showVoltar"
        :info="false"
      />
    </el-row>
    <el-row v-if="!showVoltar" style="margin: 0 20px">
      <Banner @show-dialog-permissao.passive="$emit('show-dialog-permissao', $event)" />
    </el-row>
    <div class="masonry">
      <template v-for="(item, index) in servicos">
        <FuncionalidadeBtn
          v-if="!funcionalidadeOculta(item)"
          :key="index"
          :funcionalidade="item"
          :index="index"
          @click="open(item)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { encodeEmbedData, idFuncionalidadesOcultas, isNotAccessGranted, slugGenerator } from '@/utils/utils'
import FuncionalidadeBtn from '@/components/FuncionalidadeBtn/FuncionalidadeBtn'
import Banner from '@/components/Banner/Banner'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import canal from '@/utils/canal'
import { mapGetters, mapState } from 'vuex'
import { listaFuncionalidadesTipoChat } from '@/utils/HandlerEnums'

export default {
  name: 'ListaServicos',
  components: { FuncionalidadeHeader, Banner, FuncionalidadeBtn },
  props: {
    servicos: {
      type: Array,
      default: () => []
    },
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    inboxTabId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inboxCounterEmbed: null,
      lastInboxCount: null
    }
  },
  mounted () {
    this.initInboxCounter()
  },
  beforeDestroy () {
    this.destroyInboxCounter()
  },
  metaInfo () {
    return {
      title: `${this.aplicacao.web.tituloPlataforma} - ${this.funcionalidade.nome}`
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao', 'bundle', 'instanciaAplicacao']),
    ...mapGetters('Beneficiario', ['user']),
    ...mapState('Login', ['token']),
    ...mapState('Beneficiario', ['beneficiarioCompleto']),
    paths () {
      return (String.prototype.split.call(this.$route.path, ['/']))
        .filter((p) => p !== '')
    },
    titulo () {
      return this.showVoltar ? this.funcionalidade.nome : 'Serviços'
    },
    showVoltar () {
      return this.paths.length >= 3
    }
  },
  watch: {
    inboxTabId () {
      this.reiniciarInboxCounter()
    },
    token () {
      this.reiniciarInboxCounter()
    },
    '$route.fullPath' () {
      this.reiniciarInboxCounter()
    }
  },
  methods: {
    atualizarBadgeInbox (total, metadata = {}) {
      this.$emit('inbox-badge-change', {
        total,
        source: 'bootstrap',
        ...metadata
      })
    },
    reiniciarInboxCounter () {
      this.destroyInboxCounter()
      this.$nextTick(() => {
        this.initInboxCounter()
      })
    },
    initInboxCounter () {
      if (!this.inboxTabId || !this.token || !window.omnichannelSDK || !window.omnichannelSDK.embed) {
        return
      }

      if (this.inboxCounterEmbed) {
        return
      }

      const urlBase = process.env.NODE_ENV !== 'development' ? window.location.origin : ''
      const urlFuncionalidades = process.env.VUE_APP_FUNCIONALIDADES_FRONT

      let url = urlBase + urlFuncionalidades

      if (urlFuncionalidades.startsWith('http')) {
        url = urlFuncionalidades
      }

      this.inboxCounterEmbed = window.omnichannelSDK.embed({
        id: 'lista-servicos-inbox-counter',
        url,
        json: {
          idFuncionalidade: Number(this.inboxTabId),
          authorization: this.token,
          beneficiario: this.beneficiarioCompleto,
          bundle: encodeEmbedData(this.bundle),
          plataforma: true,
          canal: canal,
          instanciaApicacao: this.instanciaAplicacao,
          permiteGeolocalizacao: true,
          minHeight: '1px'
        }
      })

      this.inboxCounterEmbed.on('INBOX_COUNT', ({ count, unread } = {}) => {
        const total = unread !== undefined && unread !== null ? unread : count
        const badgeCount = Number(total)

        if (Number.isNaN(badgeCount) || badgeCount < 0) {
          return
        }

        if (badgeCount === 0 && this.lastInboxCount !== null && this.lastInboxCount > 0) {
          return
        }

        this.lastInboxCount = badgeCount
        this.atualizarBadgeInbox(badgeCount)
      })

      this.inboxCounterEmbed.on('INBOX_CLEAR', () => {
        if (this.lastInboxCount === null || this.lastInboxCount === 0) {
          this.lastInboxCount = 0
          this.atualizarBadgeInbox(0, { clear: true })
        }
      })
    },
    destroyInboxCounter () {
      if (!this.inboxCounterEmbed) {
        return
      }

      if (typeof this.inboxCounterEmbed.destroy === 'function') {
        this.inboxCounterEmbed.destroy()
      }

      this.inboxCounterEmbed = null
      this.lastInboxCount = null
    },
    open (item) {
      let idFuncionalidade = item.id.toString()
      if (listaFuncionalidadesTipoChat.includes(idFuncionalidade)) {
        this.$emit('show-chat', {
          show: true,
          idFuncionalidade: idFuncionalidade
        })
        return
      }
      if (idFuncionalidade === null || idFuncionalidade === undefined) {
        this.$emit('show-dialog-permissao', {
          show: true,
          body: 'Funcionalidade indisponível para o usuário.'
        })
        return
      }
      if (isNotAccessGranted(idFuncionalidade)) {
        let permissao = this.user.permissoes.filter(permissao => permissao.funcionalidade === idFuncionalidade) || []
        if (permissao.length > 0) {
          this.$emit('show-dialog-permissao', {
            show: true,
            body: permissao[0].mensagemBloqueio || 'Funcionalidade indisponível para o usuário.'
          })
        } else {
          this.$emit('show-dialog-permissao', {
            show: true,
            body: 'Funcionalidade indisponível para o usuário.'
          })
        }
        return
      }
      const path = slugGenerator(item.nome)
      this.$router.push(`${this.$route.path}/${path}`)
    },
    funcionalidadeOculta (idFuncionalidade) {
      const funcionalidadesOcultas = [...idFuncionalidadesOcultas(), ...listaFuncionalidadesTipoChat]
      return funcionalidadesOcultas.includes(idFuncionalidade.id.toString())
    }
  }
}
</script>

<style scoped>
.lista-servicos {
  width: 100%;
}
.masonry {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 10px;
  padding: 20px;
}

.masonry > * {
  break-inside: avoid;
  margin-bottom: 10px;
  display: inline-block;
  width: 100%;
}

.lista-servicos-inbox-counter {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
</style>
